import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom'; // 1. Import useNavigate
import { productFaqs, dischargeFaqs, pantyFaqs, cycleFaqs, bodyTypeFaqs } from './FaqData';
import { FaqItem } from './FaqItem';
import { 
  RiSearchLine, 
  RiBox3Line, 
  RiHeartPulseLine, 
  RiTShirtLine, 
  RiSparklingLine, 
  RiUserHeartLine 
} from 'react-icons/ri';

const categories = [
  { id: 'product', label: 'Product & Tech', icon: <RiBox3Line />, data: productFaqs },
  { id: 'health', label: 'Vaginal Health', icon: <RiHeartPulseLine />, data: dischargeFaqs },
  { id: 'panty', label: 'Panty Selection', icon: <RiTShirtLine />, data: pantyFaqs },
  { id: 'cycle', label: 'Cycle Decode', icon: <RiSparklingLine />, data: cycleFaqs },
  { id: 'body', label: 'Body & Fit', icon: <RiUserHeartLine />, data: bodyTypeFaqs },
];

const Faqs = () => {
  const navigate = useNavigate(); // 2. Initialize navigate
  const [activeTab, setActiveTab] = useState('product');
  const [searchQuery, setSearchQuery] = useState('');
  const [openIndex, setOpenIndex] = useState(0); 

  // 3. Automatically open the 1st question when category changes
  useEffect(() => {
    setOpenIndex(0); 
  }, [activeTab]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currentCategory = categories.find(cat => cat.id === activeTab);
  
  const filteredData = currentCategory.data.filter(
    (item) =>
      item.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="w-full bg-[#FFFBFB] min-h-screen py-12 md:py-20">
      <div className="max-w-5xl mx-auto px-6">
        
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-4xl md:text-6xl font-black text-rose-950 mb-4 tracking-tighter">EVE-PEDIA</h1>
          <p className="text-rose-900/60 font-medium italic">"Your guide to a more comfortable, confident cycle."</p>
        </div>

     

        {/* Category Pills (Horizontal Scroll) */}
        <div className="flex overflow-x-auto pb-4 mb-10 gap-3 no-scrollbar">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveTab(cat.id)}
              className={`flex-shrink-0 flex items-center gap-2 px-6 py-3 rounded-2xl font-bold transition-all border-2 ${
                activeTab === cat.id 
                ? 'bg-rose-600 text-white border-rose-600 shadow-lg' 
                : 'bg-white text-rose-900/50 border-rose-50 hover:border-rose-200'
              }`}
            >
              <span className="text-xl">{cat.icon}</span>
              <span className="whitespace-nowrap">{cat.label}</span>
            </button>
          ))}
        </div>

        {/* FAQ List Area */}
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-[3rem] p-6 md:p-12 shadow-2xl shadow-rose-900/5 border border-rose-50 min-h-[500px]"
        >
          <div className="mb-8">
            <h3 className="text-sm font-black text-rose-300 uppercase tracking-widest mb-2">Category</h3>
            <h2 className="text-3xl font-bold text-rose-950">{currentCategory.label}</h2>
          </div>

          {filteredData.length > 0 ? (
            filteredData.map((faq, index) => (
              <FaqItem
                key={`${activeTab}-${index}`}
                question={faq.question}
                answer={faq.answer}
                isOpen={openIndex === index}
                toggle={() => setOpenIndex(openIndex === index ? -1 : index)}
              />
            ))
          ) : (
            <div className="py-20 text-center text-rose-300 font-bold">No results found.</div>
          )}
        </motion.div>

        {/* Footer CTA */}
        <div className="mt-16 bg-rose-950 rounded-[2.5rem] p-10 text-center text-white relative overflow-hidden">
          <div className="relative z-10">
            <h2 className="text-3xl font-bold mb-4">Your Comfort, Simplified.</h2>
            <p className="text-rose-200 mb-8 max-w-md mx-auto">Ready to experience the Eveya difference? Pick your product today.</p>
            
            {/* CORRECTED NAVIGATION BUTTON */}
            <button 
              className="bg-rose-500 px-10 py-4 rounded-full font-black uppercase tracking-widest hover:bg-rose-400 transition-all shadow-xl"
              onClick={() => navigate('/products')} // Arrow function prevents auto-trigger
            >
              Try the Eveya Experience
            </button>
          </div>
          
          <div className="absolute -right-20 -top-20 w-64 h-64 bg-rose-800 rounded-full blur-3xl opacity-20"></div>
          <div className="absolute -left-20 -bottom-20 w-64 h-64 bg-rose-600 rounded-full blur-3xl opacity-20"></div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;